import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { MyDocsService } from 'src/app/service/mydocs.service';
import { MyDocsModel } from 'src/app/models/upload/mydocs.model';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { HttpClient } from '@angular/common/http';
import { TableColumn } from 'src/app/home/table/TableColumn';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { Buttons } from 'src/app/home/table/Buttons';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { WorkflowTicket } from 'src/app/admin-portal/approval-flow-models/workflow-ticket.model';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { forkJoin } from 'rxjs';
 
@Component({
  selector: 'app-assign-document',
  templateUrl: './assign-document.component.html',
  styleUrls: ['./assign-document.component.css']
})
export class AssignDocumentComponent implements OnInit {
 
  userModel = new AddUser();
  userDocData: MyDocsModel[] = [];
  userDocMapData: MyDocsModel[] = [];
  filterUserDocs: MyDocsModel[] = [];
  filter: boolean = false;
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = 'userDocs Of';
  selectedUser: AddUser[] = [];
  columnsData: any;
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  actions: any;
  header: string;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  exportExcelMydocModel: MyDocsModel[] = [];
  buttons: Buttons[];

  // Header action buttons and filtering
  actionButtons: TableColumn[] = [];
  selectedDocuments: MyDocsModel[] = [];
  filteredUserDocData: MyDocsModel[] = [];
  selectedAssignedDocs: MyDocsModel[] = []; 
  

 
  public trackingid: string = "";
  public empStg: string = "";
  resdata: any;
 
  workflowTicketsData = new WorkflowTicket();
 
  @ViewChild('TABLE') table: ElementRef;
  isAccessDisabled: boolean = false;
 
 
  constructor(private router: Router, private manageUserService: ManageUserService,
    private myDocsService: MyDocsService, private notificationService: NotificationService,
    private authGaurdService: AuthGaurdService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService, private globalService: GlobalService, private approvalFlowService: ApprovalFlowService) { }
 
  ngOnInit(): void {
    console.log('ngOnInit called');
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('manage-users');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }
    console.log('ngOnInit completed - actionButtons:', this.actionButtons);
    console.log('ngOnInit completed - actionButtons length:', this.actionButtons?.length);
    console.log('ngOnInit completed - filteredUserDocData:', this.filteredUserDocData);
    console.log('ngOnInit completed - ordersTableColumns:', this.ordersTableColumns);
    console.log('ngOnInit completed - ordersTableColumns length:', this.ordersTableColumns?.length);
  }
 
  private init() {
    this.resetData();
    this.initializeColumns();
    // initializeGridConfiguration() moved to after columns are loaded
    this.prePopulatedData();
    this.initializeExcelHeaders();
  }
 
  private prePopulatedData() {
    this.empStg = "";
    console.log(this.manageUserService.selectedUserDocModel);
    for (let val of this.manageUserService.selectedUserDocModel) {
      console.log(val.employeeId);
      this.empStg = this.empStg + "," + val.employeeId;
    }
    var myString = this.empStg.substring(1);
    this.empStg = myString;
    console.log(this.empStg);
    //this.userModel = this.manageUserService.selectedUserModel;
    this.userModel = this.manageUserService.selectedUserModel;
    console.log(this.userModel);
    // this.header = 'Select Documents For ' + this.userModel.first_name + ' ' + this.userModel.last_name +
    //   ' For CommPlan OF : ' + this.userModel.commission_plan + ": Sales Channel: " + this.userModel.sales_rep_channel;
    this.header = "Select Documents To Assign";
    console.log(this.userModel);
 
    this.myDocsService.filterUserDocByEmp(this.empStg).subscribe(
      (response: MyDocsModel[]) => {
        // Map status values like user-doc-mapping
        this.userDocData = response;
        console.log("======= userDocData loaded:", this.userDocData);
        console.log("======= userDocData length:", this.userDocData.length);
        // Show all documents by default
        this.filteredUserDocData = this.userDocData;
        console.log("======= filteredUserDocData after filter:", this.filteredUserDocData);
        this.getMyDocData();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
 
  private getMyDocData() {
    if (this.userModel.sales_rep_channel) {
      this.myDocsService.getMyDocsListBySalesChannel(this.userModel.sales_channel_desc).subscribe(
        (response: MyDocsModel[]) => {
          //this.dataSource.data = response as MyDocsModel[];
          this.userDocMapData = response;
          console.log(this.userDocMapData);
          //this.filterDocs();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }
 
  private filterDocs() {
    if (this.userDocData.length > 0) {
      for (let doc of this.userDocData) {
        this.userDocMapData.forEach((userDoc: any, index: any) => {
          if (userDoc.doc_desc == doc.doc_desc) this.userDocMapData.splice(index, 1);
        });
      }
    }
    console.log(this.userDocMapData);
  }
 
  public selectedDocs(Doc: MyDocsModel) {
    console.log(Doc);
    if (this.filterUserDocs.length === 0) {
      this.filterUserDocs.push(Doc);
      this.filter = false;
    }
    else {
      this.filter = true;
      this.filterUserDocs.forEach((userDoc: any, index: any) => {
        if (userDoc.id == Doc.id) {
          this.filter = false;
          this.filterUserDocs.splice(index, 1);
        }
      });
    }
 
    if (this.filter)
      this.filterUserDocs.push(Doc);
    console.log(this.filterUserDocs);
  }
 
  public saveDoc() {
    console.log("saveDoc called");
    if (this.filterUserDocs.length > 0) {
      const user = this.authGaurdService.loginUser()
      for (let userDoc of this.filterUserDocs) {
        userDoc.comm_plan_id = this.userModel.comm_plan_id;
        userDoc.created_dt = new Date();
        userDoc.status = 'Active';
        userDoc.employeeId = this.empStg;//this.userModel.employeeId;
        userDoc.user_type = this.userModel.user_type;
        userDoc.doc_name = userDoc.doc_name;
        userDoc.created_by = user;
      }
      console.log(this.filterUserDocs);
      this.myDocsService.saveDocs(this.filterUserDocs)
        .subscribe(response => {
          // response = response as ErrorResponseMessage;
          console.log(JSON.stringify(response));
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Submitted Successfully`);
          //this.redirect('search-users');
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    } else {
      this.notificationService.sendNotification(NotificationType.ERROR, `Please select atleast 1 document`);
    }
  }
 
  public customSort = (event) => {
    console.log(event);
  }
 
 
  update(user: any, values: any) {
    if (values.value.currentTarget.checked) {
      // user.row.edit =true;
      this.filterUserDocs.push(user.row);
      console.log(this.filterUserDocs);
    } else {
      this.filterUserDocs.forEach((value: any, index: any) => {
        if (value.id == user.row.id) this.filterUserDocs.splice(index, 1);
      });
    }
  }
 
  selectAll(values: any) {
    if (values.value.currentTarget.checked) {
      this.filterUserDocs = this.userDocMapData;
 
    } else
      this.filterUserDocs = [];
  }
 
  redirect(url: string) {
    if (url === "saveDoc")
      this.saveDoc();
    //this.createTicket();
    else
      this.router.navigate(['/' + url]);
  }
  public rowAction(row: any) {
    // Individual row actions disabled - only header bulk actions are available
    // All delete functionality moved to header Delete button
  }
 
  public onDeleteEmpDoc(id: number, employeeId: string): void {
    if (confirm("Are you sure to delete this assigned document")) {
      this.myDocsService.deleteEmp(id, employeeId).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Assigned document deleted sucessfully');
          //this.redirect('search-users');
          this.init()
          // this.getAssignedDocsList(this.myDocsModel.doc_desc);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }
 
  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelMyDocs;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }
 
  public exportExcel() {
    this.exportExcelMydocModel = JSON.parse(JSON.stringify(this.userDocData));
    console.log(this.exportExcelMydocModel);
    for (let js of this.exportExcelMydocModel) {
      js.employeeName = this.userModel.first_name + ' ' + this.userModel.last_name;
      js.comm_plan_desc = this.userModel.commission_plan;
      delete js.id;
      delete js.comment;
      delete js.employeesList;
      delete js.comm_plan_id;
      delete js.comm_doc;
      delete js.status;
      delete js.comm_doc_str;
      delete js.created_dt;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.effective_dt;
      delete js.user_type;
 
      delete js.editMode;
      delete js.selected;
      delete js.sc_emp_id;
      delete js.tracking_id;
      delete js.approved_dt;
 
      delete js.approved_by;
      delete js.approved_status;
      delete js.comm_doc_id;
 
      delete js.pending_from_dt;
      delete js.scempId;
      delete js.employeeId;
      delete js.comm_plan_desc;
      delete js.approved_on;
 
    }
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelMydocModel.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'Employee Assigned DOCS',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }
 
  private resetData() {
    this.userModel = new AddUser();
    this.userDocData = [];
    this.userDocMapData = [];
    this.filterUserDocs = [];
    this.filter = false;
    this.selectedUser = [];
    this.columnsData = []
    this.ordersTableColumns = [];
    this.ordersTableColumns2 = [];
    this.header = '';
    this.selectedDocuments = [];
    this.filteredUserDocData = [];
  }
 
  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.UserDocColumns;
        console.log(this.ordersTableColumns);
        // Initialize action buttons after columns are loaded
        this.initializeGridConfiguration();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
 
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns2 = this.columnsData.UserDocCol;
        console.log(this.ordersTableColumns2);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      // Removed individual delete action - only header bulk delete is available
    ]
 
    this.buttons = [
      {
        name: 'Back',
        pagenavigation: 'search-users'
      },
      {
        name: 'Save',
        pagenavigation: 'saveDoc'
      }
    ]
  }

  initializeGridConfiguration(): void {
    this.actionButtons = [
      {
        name: 'Delete',
        class: 'btn btn-danger btn-xs'
      }
    ];
    console.log('Action buttons initialized:', this.actionButtons);
    console.log('action button shows', this.actionButtons.length);
  }

  actionOnButton(action: string): void {
    if (this.isAccessDisabled) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      return;
    }

    switch (action) {
      case 'Delete':
        this.deleteSelectedAssignedDocs();
        break;
    }
  }
deleteSelectedAssignedDocs(): void {
  if (!this.selectedAssignedDocs || this.selectedAssignedDocs.length === 0) {
    this.notificationService.sendNotification(NotificationType.ERROR, 'Please select at least one document to delete.');
    return;
  }

  if (!confirm(`Are you sure you want to delete ${this.selectedAssignedDocs.length} document(s)?`)) {
    return;
  }

  const validDocsToDelete = this.selectedAssignedDocs.filter(doc => (doc.comm_doc_id || doc.id) && doc.employeeId);

  if (validDocsToDelete.length === 0) {
    this.notificationService.sendNotification(NotificationType.ERROR, 'No valid documents selected to delete.');
    return;
  }

  console.log(`Deleting ${validDocsToDelete.length} document(s)...`);

  const deleteCalls = validDocsToDelete.map(doc => {
    const docId = doc.comm_doc_id || doc.id;
    return this.myDocsService.deleteEmp(docId, doc.employeeId);
  });

  forkJoin(deleteCalls).subscribe({
    next: () => {
      console.log(`Successfully deleted ${validDocsToDelete.length} document(s).`);
      this.notificationService.sendNotification(NotificationType.SUCCESS, `${validDocsToDelete.length} document(s) deleted successfully.`);
      this.selectedAssignedDocs = [];
      this.init();  // Refresh the data
    },
    error: (err) => {
      console.error('Error during document deletion:', err);
      this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to delete one or more documents.');
    }
  });
}

onAssignedDocCheckboxChange(event: any): void {
  const row = event.row;
  const isChecked = event.value?.currentTarget?.checked;

  if (!row || isChecked === undefined) return;

  if (isChecked) {
    if (!this.selectedAssignedDocs.find(doc => doc.comm_doc_id === row.comm_doc_id)) {
      this.selectedAssignedDocs.push(row);
      console.log(`Document selected: comm_doc_id=${row.comm_doc_id}`);
    }
  } else {
    this.selectedAssignedDocs = this.selectedAssignedDocs.filter(doc => doc.comm_doc_id !== row.comm_doc_id);
    console.log(`Document deselected: comm_doc_id=${row.comm_doc_id}`);
  }
}

onAssignedDocSelectAllChange(event: any): void {
  const isChecked = event?.value?.currentTarget?.checked;

  if (isChecked === undefined) return;

  if (isChecked) {
    this.selectedAssignedDocs = [...this.filteredUserDocData];
    console.log(`All documents selected (${this.selectedAssignedDocs.length})`);
  } else {
    this.selectedAssignedDocs = [];
    console.log('All documents deselected');
  }
}
}